<template>
  <div class="app-ident-data-select">
    <div class="form-row">
      <b-form-group class="nationality-group custom-input-select mandatory">
      <InputAutocomplete
        :input-id="'nationality-select-input-field'"
        :autocomplete-list-id="'nationality-select-input-list'"
        :clear-input-id="'nationality-search-clear-input'"
        :label="getSlotText('lblNationality')"
        :inputAriaLabel="getSlotText('txtAriaLabelNationality')"
        :listAriaLabel="getSlotText('txtAriaLabelListNationality','Liste von Staatsangehörigkeiten')"
        :data="filteredAllIdentMethods"
        :placeholder="getSlotText('txtPlaceholderNationality')"
        object-key-name="name"
        @selectedItemChange="nationalityChange($event)"
        :sort-data=false
        :last="findLastHighCountry"
        :label-icon-with-modal=true
        :default-icon="'arrow'"
        :not-found-input-msg="'Keine Ergebnisse'"
        :show-success-icon=false
        :stored-item="selectedNationality"
        :aria-described-by="'nationality-select-input-field_info-box'"
        focus-next="#ident-select-input-field"
      >
        <template v-for="slot in possibleChildSlotsFor('Autocomplete')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </InputAutocomplete>
      </b-form-group>
      <b-form-group class="ident-card-group custom-input-select mandatory">
      <InputAutocomplete
        :input-id="'ident-select-input-field'"
        :autocomplete-list-id="'ident-select-input-list'"
        :label="getSlotText('lblIdentType')"
        :inputAriaLabel="getSlotText('txtAriaLabelIdentType')"
        :listAriaLabel="getSlotText('txtAriaLabelListIdentType','Liste von Ausweistypen')"
        :data='identityCardOptions'
        :placeholder="!identSelectable ? '---' : getSlotText('lblPlaceholderIdentType')"
        object-key-name="text"
        @selectedItemChange="identCardChange($event)"
        ref="identCard"
        :disabled="!identSelectable"
        :default-icon="'arrow'"
        :hard-filter=false
        :show-success-icon=false
        :pointer=true
        :show-always-default-icon=true
        :sort-data=false
        :read-only=true
        :stored-item="selectedIdent"
        :with-focus=true
      />
      </b-form-group>
    </div>
  </div>
</template>

<script>
import syncProperty from '@/mixins/syncProperty'
import InputAutocomplete from '@/components/generic/InputAutocomplete.vue'

export default {
  name: 'IdentDataSelect',
  components: {
    InputAutocomplete
  },
  mounted () {
    this.countryNotAvailableErrorTxt()
  },
  data () {
    return {
      preSavedCountry: '',
      notAvailableCountryErrorTxt: ''
    }
  },
  mixins: [
    syncProperty('ident', 'selectedIdent'),
    syncProperty('nationality', 'selectedNationality')
  ],
  methods: {
    countryNotAvailableErrorTxt: function () {
      this.notAvailableCountryErrorTxt = this.getSlotText('txtNoValidPassport')
    },
    isMatchingCountry: function (name) {
      return this.nationalityOptions.some(country =>
        country.text.toLowerCase() === name.toLowerCase()
      )
    },
    nationalityChange (country) {
      if (this.isMatchingCountry(country)) {
        this.selectedNationality = country
        this.$refs.identCard.reactOnUserInput('')
      } else {
        this.selectedNationality = ''
        this.$refs.identCard.resetAutocompleteInputField()
      }
    },
    identCardChange (identCardOption) {
      this.selectedIdent = identCardOption
    }
  },
  computed: {
    identSelectable: function () {
      return (this.identityCardOptions.length > 0 && this.selectedNationality)
    },
    findLastHighCountry: function () {
      const liste = this.nationalityOptions.filter(nationality => {
        return (nationality.frequency === 'high')
      })
      const last = liste.pop()
      return last?.text
    },
    nationalityOptions: function () {
      return this.filteredAllIdentMethods.map(identType => {
        return {
          value: identType,
          text: identType.name,
          frequency: identType.frequency
        }
      })
    },
    filteredAllIdentMethods: function () {
      const fullList = []
      if (this.allIdentMethods) {
        this.allIdentMethods.identTypes.forEach(item => {
          if (this.quickSelectionCountryIdent.find(el => item.name === el) !== undefined) {
            item.frequency = 'high'
            fullList.push(item)
          }
        })

        this.allIdentMethods.identTypes.forEach(item => {
          if (this.quickSelectionCountryIdent.find(el => item.name === el) === undefined) {
            item.frequency = 'low'
            fullList.push(item)
          }
        })
      }

      return fullList
    },
    identityCardOptions: function () {
      if (this.selectedNationality) {
        const nationality = this.nationalityOptions.find((country) => {
          return (country.text.toLowerCase().indexOf(this.selectedNationality.toLowerCase()) === 0)
        })
        const identityCardOptions = nationality?.value.passports || []
        const filteredOptions = identityCardOptions.map(passport => {
          return {
            value: passport,
            text: passport.name
          }
        }).filter(passport => {
          return (passport.value.identMethods.includes('store') || passport.value.identMethods.includes('video'))
        })
        return filteredOptions
      } else {
        return []
      }
    },
    quickSelectionCountryIdent: function () {
      const slot = this.getSlotText('txtQuickSelectionList')
      return slot.split(',').map(function (item) {
        return item.trim()
      })
    },
    isCountryAvailable () {
      return (
        this.selectedNationality === '' ||
        this.identityCardOptions.length > 0
      )
    }
  },
  props: {
    allIdentMethods: {
      type: Object,
      default: null
    }
  },
  watch: {
    isCountryAvailable (value) {
      if (!value) {
        this.errorToast(this.notAvailableCountryErrorTxt)
      }
    }
  }
}
</script>
